import React from "react";
import { ArrowRight, Compass, Sparkles, Zap } from "lucide-react";

// High-placement, band-specific action button rendered right under the hero
// score card. This is in addition to the existing CTABlock further down the
// page, not a replacement. The button never inflates a score; for Yellow it
// scrolls to the honest reframe block.
const CONFIG = {
  green: {
    label: "Build it in 6 minutes",
    helper: "You have a Greenlight. Skip months of brand, copy, and tech.",
    icon: Zap,
    mode: "external",
  },
  yellow: {
    label: "Improve this idea",
    helper: "See the sharper version that scores higher, and the reasoning behind it.",
    icon: Sparkles,
    mode: "scroll",
  },
  red: {
    label: "Get a greenlit idea instead",
    helper: "This one is tough. Our Idea Engine hands you one that actually works.",
    icon: Compass,
    mode: "external",
  },
};

export default function HeroBandCTA({
  band = "yellow",
  offerUrl = "https://trylightbulb.com/offer",
}) {
  const cfg = CONFIG[band] || CONFIG.yellow;
  const Icon = cfg.icon;

  const onScrollClick = (e) => {
    e.preventDefault();
    const el = document.getElementById("sharper-version");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const buttonInner = (
    <>
      <Icon size={18} />
      {cfg.label}
      <ArrowRight size={18} />
    </>
  );

  return (
    <div
      className="gl-card-lift p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5"
      data-testid={`hero-cta-${band}`}
    >
      <div className="flex-1 min-w-0">
        <div className="gl-label mb-1">Your next step</div>
        <p className="text-sm sm:text-base text-white leading-snug">
          {cfg.helper}
        </p>
      </div>
      {cfg.mode === "scroll" ? (
        <button
          type="button"
          onClick={onScrollClick}
          className="gl-cta gl-cta-block sm:w-auto whitespace-nowrap text-sm sm:text-base"
          data-testid={`hero-cta-${band}-button`}
        >
          {buttonInner}
        </button>
      ) : (
        <a
          href={offerUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="gl-cta gl-cta-block sm:w-auto whitespace-nowrap text-sm sm:text-base"
          data-testid={`hero-cta-${band}-button`}
        >
          {buttonInner}
        </a>
      )}
    </div>
  );
}
